import { render, staticRenderFns } from "./medicament-select.vue?vue&type=template&id=9a9cd714"
import script from "./medicament-select.vue?vue&type=script&lang=js"
export * from "./medicament-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports